const link = process.env.REACT_APP_SERVER_API_V2

export const getEditCharger = () => `${link}/charger`


